<app-nav></app-nav>

<app-home-hero-ai-landing id="main"></app-home-hero-ai-landing>
<lib-main-theses [lang]="'en'"></lib-main-theses>
<app-about-us-ai id="about-us"></app-about-us-ai>

<app-publications id="publications"></app-publications>
<app-for-whoom [type]="'ai'" id="for_whom"></app-for-whoom>

<app-faq></app-faq>
<!--<app-not-supported-mobile class="mobile-block"></app-not-supported-mobile>-->
<app-footer></app-footer>
<!--<lib-promo-handler [apiUrl]="apiUrl" [userData]="auth.userData"></lib-promo-handler>-->
<!--<lib-promo-code-handler [apiUrl]="apiUrl" [userData]="auth.userData"></lib-promo-code-handler>-->
